import { GlLoadingIcon } from '@gitlab/ui';
import { MR_WIDGET_PREPARING_ASYNCHRONOUSLY } from '../../i18n';
export default {
    name: 'MRWidgetPreparing',
    i18n: {
        preparing: MR_WIDGET_PREPARING_ASYNCHRONOUSLY
    },
    components: {
        GlLoadingIcon
    }
};
